"use strict";
const podcastTypeFieldsetSelector = '.js-add_podcast_type';
const addPodcastButtonSelector = '.js-add_podcast_button';
window.up.compiler(podcastTypeFieldsetSelector, (podcastTypeFieldset) => {
    const addPodcastButton = document.querySelector(addPodcastButtonSelector);
    if (addPodcastButton) {
        window.up.on(podcastTypeFieldset, 'change', undefined, (_event, input) => {
            addPodcastButton.href = input.value;
        });
    }
});
